/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { Number } from '../models/number';
import { procedureControllerCreate } from '../fn/procedure/procedure-controller-create';
import { ProcedureControllerCreate$Params } from '../fn/procedure/procedure-controller-create';
import { procedureControllerDeleteProcedure } from '../fn/procedure/procedure-controller-delete-procedure';
import { ProcedureControllerDeleteProcedure$Params } from '../fn/procedure/procedure-controller-delete-procedure';
import { procedureControllerExportProcedures } from '../fn/procedure/procedure-controller-export-procedures';
import { ProcedureControllerExportProcedures$Params } from '../fn/procedure/procedure-controller-export-procedures';
import { procedureControllerGetAll } from '../fn/procedure/procedure-controller-get-all';
import { ProcedureControllerGetAll$Params } from '../fn/procedure/procedure-controller-get-all';
import { procedureControllerGetAllStatuses } from '../fn/procedure/procedure-controller-get-all-statuses';
import { ProcedureControllerGetAllStatuses$Params } from '../fn/procedure/procedure-controller-get-all-statuses';
import { procedureControllerGetAllTypes } from '../fn/procedure/procedure-controller-get-all-types';
import { ProcedureControllerGetAllTypes$Params } from '../fn/procedure/procedure-controller-get-all-types';
import { procedureControllerGetNextProcedureStatuses } from '../fn/procedure/procedure-controller-get-next-procedure-statuses';
import { ProcedureControllerGetNextProcedureStatuses$Params } from '../fn/procedure/procedure-controller-get-next-procedure-statuses';
import { procedureControllerGetOne } from '../fn/procedure/procedure-controller-get-one';
import { ProcedureControllerGetOne$Params } from '../fn/procedure/procedure-controller-get-one';
import { procedureControllerGetTimeline } from '../fn/procedure/procedure-controller-get-timeline';
import { ProcedureControllerGetTimeline$Params } from '../fn/procedure/procedure-controller-get-timeline';
import { procedureControllerUpdateProcedureStatus } from '../fn/procedure/procedure-controller-update-procedure-status';
import { ProcedureControllerUpdateProcedureStatus$Params } from '../fn/procedure/procedure-controller-update-procedure-status';
import { procedureControllerWidgetAllStatusProcedures } from '../fn/procedure/procedure-controller-widget-all-status-procedures';
import { ProcedureControllerWidgetAllStatusProcedures$Params } from '../fn/procedure/procedure-controller-widget-all-status-procedures';
import { ProcedureItem } from '../models/procedure-item';
import { ProcedureItemList } from '../models/procedure-item-list';
import { ProcedureStatusItemList } from '../models/procedure-status-item-list';
import { ProcedureTypeItemList } from '../models/procedure-type-item-list';
import { TimelineList } from '../models/timeline-list';

@Injectable({ providedIn: 'root' })
export class ProcedureService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `procedureControllerGetAll()` */
  static readonly ProcedureControllerGetAllPath = '/procedure';

  /**
   * Ritorna tutte le pratiche.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `procedureControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerGetAll$Response(params?: ProcedureControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItemList;
}>> {
    const obs = procedureControllerGetAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna tutte le pratiche.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `procedureControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerGetAll(params?: ProcedureControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProcedureItemList;
}> {
    const resp = this.procedureControllerGetAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItemList;
}>): BaseResponse & {
'data'?: ProcedureItemList;
} => r.body)
    );
  }

  /** Path part for operation `procedureControllerCreate()` */
  static readonly ProcedureControllerCreatePath = '/procedure';

  /**
   * Crea una pratica.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `procedureControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  procedureControllerCreate$Response(params: ProcedureControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItem;
}>> {
    const obs = procedureControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Crea una pratica.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `procedureControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  procedureControllerCreate(params: ProcedureControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProcedureItem;
}> {
    const resp = this.procedureControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItem;
}>): BaseResponse & {
'data'?: ProcedureItem;
} => r.body)
    );
  }

  /** Path part for operation `procedureControllerExportProcedures()` */
  static readonly ProcedureControllerExportProceduresPath = '/procedure/export';

  /**
   * Esporta le pratiche filtrate in formato Excel.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `procedureControllerExportProcedures()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerExportProcedures$Response(params?: ProcedureControllerExportProcedures$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = procedureControllerExportProcedures(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Esporta le pratiche filtrate in formato Excel.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `procedureControllerExportProcedures$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerExportProcedures(params?: ProcedureControllerExportProcedures$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.procedureControllerExportProcedures$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `procedureControllerGetAllStatuses()` */
  static readonly ProcedureControllerGetAllStatusesPath = '/procedure/statuses';

  /**
   * Ritorna l'elenco delgli stati delle pratiche.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `procedureControllerGetAllStatuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerGetAllStatuses$Response(params?: ProcedureControllerGetAllStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProcedureStatusItemList;
}>> {
    const obs = procedureControllerGetAllStatuses(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna l'elenco delgli stati delle pratiche.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `procedureControllerGetAllStatuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerGetAllStatuses(params?: ProcedureControllerGetAllStatuses$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProcedureStatusItemList;
}> {
    const resp = this.procedureControllerGetAllStatuses$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProcedureStatusItemList;
}>): BaseResponse & {
'data'?: ProcedureStatusItemList;
} => r.body)
    );
  }

  /** Path part for operation `procedureControllerGetAllTypes()` */
  static readonly ProcedureControllerGetAllTypesPath = '/procedure/types';

  /**
   * Ritorna l'elenco delgli stati delle pratiche.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `procedureControllerGetAllTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerGetAllTypes$Response(params?: ProcedureControllerGetAllTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProcedureTypeItemList;
}>> {
    const obs = procedureControllerGetAllTypes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna l'elenco delgli stati delle pratiche.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `procedureControllerGetAllTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerGetAllTypes(params?: ProcedureControllerGetAllTypes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProcedureTypeItemList;
}> {
    const resp = this.procedureControllerGetAllTypes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProcedureTypeItemList;
}>): BaseResponse & {
'data'?: ProcedureTypeItemList;
} => r.body)
    );
  }

  /** Path part for operation `procedureControllerWidgetAllStatusProcedures()` */
  static readonly ProcedureControllerWidgetAllStatusProceduresPath = '/procedure/status-widget';

  /**
   * Ritorna il nummero delle pratiche per stato.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `procedureControllerWidgetAllStatusProcedures()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerWidgetAllStatusProcedures$Response(params: ProcedureControllerWidgetAllStatusProcedures$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: Number;
}>> {
    const obs = procedureControllerWidgetAllStatusProcedures(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna il nummero delle pratiche per stato.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `procedureControllerWidgetAllStatusProcedures$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerWidgetAllStatusProcedures(params: ProcedureControllerWidgetAllStatusProcedures$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: Number;
}> {
    const resp = this.procedureControllerWidgetAllStatusProcedures$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: Number;
}>): BaseResponse & {
'data'?: Number;
} => r.body)
    );
  }

  /** Path part for operation `procedureControllerGetOne()` */
  static readonly ProcedureControllerGetOnePath = '/procedure/{id}';

  /**
   * Ritorna una preatica per id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `procedureControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerGetOne$Response(params: ProcedureControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItem;
}>> {
    const obs = procedureControllerGetOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna una preatica per id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `procedureControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerGetOne(params: ProcedureControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProcedureItem;
}> {
    const resp = this.procedureControllerGetOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItem;
}>): BaseResponse & {
'data'?: ProcedureItem;
} => r.body)
    );
  }

  /** Path part for operation `procedureControllerDeleteProcedure()` */
  static readonly ProcedureControllerDeleteProcedurePath = '/procedure/{id}';

  /**
   * Ritorna una preatica per id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `procedureControllerDeleteProcedure()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerDeleteProcedure$Response(params: ProcedureControllerDeleteProcedure$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItem;
}>> {
    const obs = procedureControllerDeleteProcedure(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna una preatica per id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `procedureControllerDeleteProcedure$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerDeleteProcedure(params: ProcedureControllerDeleteProcedure$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProcedureItem;
}> {
    const resp = this.procedureControllerDeleteProcedure$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItem;
}>): BaseResponse & {
'data'?: ProcedureItem;
} => r.body)
    );
  }

  /** Path part for operation `procedureControllerGetTimeline()` */
  static readonly ProcedureControllerGetTimelinePath = '/procedure/{id}/timeline';

  /**
   * Restituisce la timeline della pratica inserita.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `procedureControllerGetTimeline()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerGetTimeline$Response(params: ProcedureControllerGetTimeline$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TimelineList;
}>> {
    const obs = procedureControllerGetTimeline(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce la timeline della pratica inserita.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `procedureControllerGetTimeline$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerGetTimeline(params: ProcedureControllerGetTimeline$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: TimelineList;
}> {
    const resp = this.procedureControllerGetTimeline$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: TimelineList;
}>): BaseResponse & {
'data'?: TimelineList;
} => r.body)
    );
  }

  /** Path part for operation `procedureControllerGetNextProcedureStatuses()` */
  static readonly ProcedureControllerGetNextProcedureStatusesPath = '/procedure/{id}/next-procedure-status';

  /**
   * Restituisce lo stato successivo disponibile della pratica.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `procedureControllerGetNextProcedureStatuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerGetNextProcedureStatuses$Response(params: ProcedureControllerGetNextProcedureStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProcedureStatusItemList;
}>> {
    const obs = procedureControllerGetNextProcedureStatuses(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce lo stato successivo disponibile della pratica.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `procedureControllerGetNextProcedureStatuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  procedureControllerGetNextProcedureStatuses(params: ProcedureControllerGetNextProcedureStatuses$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProcedureStatusItemList;
}> {
    const resp = this.procedureControllerGetNextProcedureStatuses$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProcedureStatusItemList;
}>): BaseResponse & {
'data'?: ProcedureStatusItemList;
} => r.body)
    );
  }

  /** Path part for operation `procedureControllerUpdateProcedureStatus()` */
  static readonly ProcedureControllerUpdateProcedureStatusPath = '/procedure/{id}/status';

  /**
   * Modifica lo stato di una pratica per id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `procedureControllerUpdateProcedureStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  procedureControllerUpdateProcedureStatus$Response(params: ProcedureControllerUpdateProcedureStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItem;
}>> {
    const obs = procedureControllerUpdateProcedureStatus(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Modifica lo stato di una pratica per id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `procedureControllerUpdateProcedureStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  procedureControllerUpdateProcedureStatus(params: ProcedureControllerUpdateProcedureStatus$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ProcedureItem;
}> {
    const resp = this.procedureControllerUpdateProcedureStatus$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItem;
}>): BaseResponse & {
'data'?: ProcedureItem;
} => r.body)
    );
  }

}
